import { useNavigate } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

export const PaymentSuccess = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-paper flex items-center justify-center py-16 px-6">
      <div className="max-w-md text-center">
        <CheckCircle2 className="w-16 h-16 mx-auto mb-6" strokeWidth={1.5} />
        <div className="caps text-muted mb-3">Payment received</div>
        <h1 className="font-serif text-4xl md:text-5xl mb-4" data-testid="payment-success-title">
          Thanks. You&apos;re <em className="italic">in.</em>
        </h1>
        <p className="text-muted mb-8">Your listing slot is active for 3 months. Next step: fill in property details and upload photos.</p>
        <button onClick={() => navigate('/host/create-listing')} className="btn-editorial btn-solid" data-testid="continue-listing-btn">
          Continue to listing form →
        </button>
      </div>
    </div>
  );
};
